import React, { createContext, useContext, useState, useEffect } from 'react';
import { importPrivateKey } from '../components/functions/cryptoUtils';

const SecurityContext = createContext(null);

export const SecurityProvider = ({ children }) => {
  const [userPrivateKey, setUserPrivateKey] = useState(null); // The actual CryptoKey Object
  const [isReady, setIsReady] = useState(false); // To block UI until checks are done

  useEffect(() => {
    const loadIdentity = async () => {
      // 1. Check if we have an active session key
      const storedKeyPEM = sessionStorage.getItem("userIdentity");
      
      if (storedKeyPEM) {
        try {
          // 2. Restore the Key Object from the PEM String
          // We don't need the password here because it's already decrypted in storage
          const keyObj = await importPrivateKey(storedKeyPEM);
          setUserPrivateKey(keyObj);
        } catch (e) {
          console.error("Session corrupted:", e);
          sessionStorage.removeItem("userIdentity");
        }
      }
      setIsReady(true);
    };

    loadIdentity();
  }, []);

  // Call this immediately after user enters password & login API returns success
  const saveIdentity = (pemString) => {
    // 1. Save to Session (Persist on Refresh)
    sessionStorage.setItem("userIdentity", pemString);
    
    // 2. Save to Memory (Update App State immediately)
    importPrivateKey(pemString).then(keyObj => setUserPrivateKey(keyObj));
  };

  const clearIdentity = () => {
    sessionStorage.removeItem("userIdentity");
    setUserPrivateKey(null);
  };

  return (
    <SecurityContext.Provider value={{ userPrivateKey, isReady, saveIdentity, clearIdentity }}>
      {children}
    </SecurityContext.Provider>
  );
};

export const useSecurity = () => useContext(SecurityContext);